// 客户端登陆类型

import { base } from '@/base/base'
import { MsgIDs } from '@/defines/MsgIDs'
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { DataKeyDefine } from '@/defines/DataKeyDefine'
import * as proto from '@/proto/proto.js'
import { log, bytesToString } from '@/utils/functions'
import { Language } from '@/defines/Language'
import { Language as Language_my } from '@/defines/Language_my'
import { Language as Language_pak } from '@/defines/Language_pak'
import { Language as Language_tr } from '@/defines/Language_tr'
import { serverErrorMsg } from '@/defines/ServerError'
import { AppEvents } from '@/defines/EnumDefine'
import { Utility } from '@/utils/TimeUtils'
import { UIUtil } from '@/utils/UIUtil'
import { Utils } from '@/utils/Utils'
import { wsClient } from '@/net/WebSocketClient'

// 来源  1：游客 ；2：微信登录; 3: 账号密码；4：FB登录
export enum LoginType {
  None = 0, // 没有登录信息
  Guest = 1, // 游客
  WeChat = 2, // 微信
  Account = 3, // 账号密码
  FaceBook = 4, // facebook登陆
  Mobile = 5, // 最新手机免注册登录方式
  Apple = 6,
  Token = 7, // 客户端添加并用于 token 自动登录
  Google = 8,
}

export class LoginModule extends ModuleBase {
  private agreePolicy_: boolean | undefined

  public _preLoad: boolean = false
  public loginType = LoginType.None

  public timePanel = null

  public isBindPhone = false
  public phoneNum = ''
  public otp = ''
  public isFirstLogin = false //注册了之后第一次登录游戏
  private _pendingReqLoginType: LoginType = LoginType.None
  connectSocketSucForLogin: any

  public init(): void {}

  public onClear(): void {
    if (this.timePanel) {
      ;(Utility as any).cancelTimer(this.timePanel)
    }
    this.timePanel = null
  }

  public onLoad(): void {}

  public onDestroy(): void {}

  public onPreloadData(): void {}

  public setPolicyAgree(agree: boolean): void {
    this.agreePolicy_ = agree
  }

  public getPolicyAgree(): boolean {
    return this.agreePolicy_ || false
  }

  connectSuccess() {
    log(`LoginModule connectSuccess`)

    if (this.connectSocketSucForLogin) {
      ;(globalThis as any)['onResigsterSuccess'] = () => {
        this.loginByToken('')
      }
      ;(globalThis as any)['onLoginSuccess'] = () => {
        this.loginByToken('')
      }
      this.connectSocketSucForLogin()
      this.connectSocketSucForLogin = null
    } else {
      this.reLogin()
    }
  }

  loginByToken(token: string, firstTime: boolean = false): void {
    const msg = {
      Token: token,
      CheckLogin: 'LaMiLeiSi@20220901',
      ClientMark: Utils.getUUID(),
      FirstTime: firstTime,
      Channel: base.channelId,
    }

    if (wsClient.isNetConnected()) {
      wsClient.send(MsgIDs.Client2ProxyReqTokenLogin, msg)
    } else {
      const connectSocketSucForLogin = () => {
        wsClient.send(MsgIDs.Client2ProxyReqTokenLogin, msg)
      }
      this.connectSocketSucForLogin = connectSocketSucForLogin
      wsClient.connect()
    }
  }

  public loginByGuest(): void {
    log('loginByGuest')

    this._pendingReqLoginType = LoginType.Guest
    const msg = {
      Origin: LoginType.Guest,
      ClientMark: Utils.getUUID(),
      platformType: base.app.getPlatformType(),
      regChannel: base.channelId,
      channel: base.channelId,
      version: base.app.version,
      CheckLogin: 'LaMiLeiSi@20220901',
    }

    if (wsClient.isNetConnected()) {
      wsClient.send(MsgIDs.Client2ProxyReqLogin, msg)
    } else {
      const connectSocketSucForLogin = () => {
        wsClient.send(MsgIDs.Client2ProxyReqLogin, msg)
      }

      this.connectSocketSucForLogin = connectSocketSucForLogin
      wsClient.connect()
    }
  }

  public getGoogleIdToken() {
    const v = localStorage.getItem(DataKeyDefine.GoogleIdToken)
    return v == null ? '' : v
  }

  public setGoogleIdToken(token: string) {
    if (!token) {
      localStorage.removeItem(DataKeyDefine.GoogleIdToken)
      return
    }
    localStorage.setItem(DataKeyDefine.GoogleIdToken, token)
  }

  public loginByGoogleIdToken(idToken: string) {
    if (!idToken) {
      return
    }

    this._pendingReqLoginType = LoginType.Google

    const msg = {
      Origin: LoginType.Google,
      Type: 1,
      strToken: idToken,
      ClientMark: Utils.getUUID(),
      platformType: base.app.getPlatformType(),
      regChannel: base.channelId,
      channel: base.channelId,
      version: base.app.version,
      CheckLogin: 'LaMiLeiSi@20220901',
    }

    if (wsClient.isNetConnected()) {
      wsClient.send(MsgIDs.Client2ProxyReqLogin, msg)
    } else {
      const connectSocketSucForLogin = () => {
        wsClient.send(MsgIDs.Client2ProxyReqLogin, msg)
      }
      this.connectSocketSucForLogin = connectSocketSucForLogin
      wsClient.connect()
    }
  }

  public sendReqMobileSmsCode(phoneNum: string): boolean {
    if (!UIUtil.checkPakPhone(phoneNum)) {
      base.toast(hall.Language.MobileNumInvalid)
      return false
    }

    const msg = {
      PhoneNumber: phoneNum,
      Channel: base.channelId,
    }

    if (wsClient.isNetConnected()) {
      wsClient.send(MsgIDs.Client2ProxyReqMobileSmsCode, msg)
    } else {
      const connectSocketSucForLogin = () => {
        wsClient.send(MsgIDs.Client2ProxyReqMobileSmsCode, msg)
      }
      this.connectSocketSucForLogin = connectSocketSucForLogin
      wsClient.connect()
    }

    return true
  }

  public loginByPhoneNum(phoneNum: string, optStr: string): void {
    if (!UIUtil.checkPakPhone(phoneNum)) {
      base.toast(hall.Language.MobileNumInvalid)
      return
    }

    if (!UIUtil.checkPhoneOTP(optStr)) {
      base.toast(hall.Language.InvalidSmscode)
      return
    }

    if (!hall.userModule.message_id || hall.userModule.message_id == 'undefined') {
      hall.userModule.message_id = '0'
    }

    const msg = {
      clientMark: Utils.getUUID(),
      modileNum: phoneNum,
      smsCode: optStr,
      platformType: base.app.getPlatformType(),
      regChannel: base.channelId,
      channel: base.channelId,
      version: base.app.version,
      messageID: hall.userModule.message_id,
      IsBing: this.isBindPhone,
    }

    if (wsClient.isNetConnected()) {
      wsClient.send(MsgIDs.Client2ProxyReqMoblieLogin, msg)
    } else {
      const connectSocketSucForLogin = () => {
        wsClient.send(MsgIDs.Client2ProxyReqMoblieLogin, msg)
      }
      this.connectSocketSucForLogin = connectSocketSucForLogin
      wsClient.connect()
    }
  }

  public cleanBindInfo() {
    base.uiHudSystem.hide('SystemWaitingCopy')
    this.isBindPhone = false
    this.phoneNum = ''
    this.otp = ''
    hall.userModule.message_id = '0'
    this._preLoad = false
  }

  getLastLoginType(): LoginType {
    const last = localStorage.getItem(DataKeyDefine.LastLoginType)
    if (last == null) {
      return LoginType.None
    }

    return (LoginType as any)[last] || LoginType.None
  }

  setLastLoginType(type: LoginType): void {
    localStorage.setItem(DataKeyDefine.LastLoginType, LoginType[type])
  }

  sendReqLogout() {
    if (this.timePanel == null) {
      base.uiHudSystem.show('SystemWaitingCopy', hall.Language.Loggings)
      const err = () => {
        base.toast(hall.Language.panelShowErroe)
        base.uiHudSystem.hide('SystemWaitingCopy')
        if (this.timePanel) {
          ;(Utility as any).cancelTimer(this.timePanel)
        }
        this.timePanel = null
      }

      this.timePanel = (Utility as any).scheduleOnce(err, 10)
    }
    const msg = {
      UserID: hall.userModule.userId,
    }
    wsClient.send(MsgIDs.Client2ProxyReqLogout, msg)
  }

  loginFail() {
    this.disconnectToLoginPanel()

    const token = base.app.token
    if (token != null && token !== '') {
      base.app.token = ''
    }

    if (this._pendingReqLoginType === LoginType.Google) {
      this.setGoogleIdToken('')
    }
  }

  disconnectToLoginPanel() {
    hall.userModule.lastSendTime = 0
    this._preLoad = false
    this.deleView()
    for (const module of hall.moduleManager as any[]) {
      if (typeof (module as any).clearModules === 'function') (module as any).clearModules()
    }
    ;(hall.moduleManager as any).clearModules()
    this.toLoginPanel()
  }

  deleView() {
    base.uiHudSystem.hide('SignPanel')
    base.uiHudSystem.hide('PinDuoPanel')
    base.uiHudSystem.hide('BindingBeforePanel')
  }

  toLoginPanel() {
    base.uiHudSystem.show('LoginPanel')
  }

  changeLanguage(language: string) {
    ;(globalThis as any).i18nMgr.setChangeLanguage(language)
    const currentLang = (globalThis as any).i18nMgr.getLanguage()
    if (currentLang == 'my') {
      hall.Language = Language_my
    } else if (currentLang == 'pak') {
      hall.Language = Language_pak
    } else if (currentLang == 'tr') {
      hall.Language = Language_tr
    } else {
      hall.Language = Language
    }
    hall.hallModule.init()
  }

  loadingLogin() {
    hall.userModule.sendClient2ProxyReqGetBalance()

    const actReq = proto.Client2ProxyReqActivityDetail.create({ UserID: 0 })
    ;(wsClient as any).send(
      MsgIDs.Client2ProxyReqActivityDetail,
      proto.Client2ProxyReqActivityDetail.encode(actReq).finish(),
    )

    hall.hallModule.showHall()
    base.uiHudSystem.hide('UpdatePanel')
    base.uiHudSystem.hide('LoginPanel')
    base.uiHudSystem.hide('RegisterPanel')
    base.uiHudSystem.hide('SystemWaitingCopy')
    base.uiHudSystem.hide('LoginInPanel')
  }

  inits2c() {
    log('LoginModule inits2c')

    ;(hall.s2c as any)['onClient2SrvHeartBeatAck'] = (_msg: proto.Client2SrvHeartBeatAck) => {}

    ;(hall.s2c as any)['onClient2ProxyAckMobileSmsCode'] = (
      _msg: proto.Client2ProxyAckMobileSmsCode,
    ) => {
      if (_msg.Ret == 0) {
        hall.userModule.message_id = _msg.MessageID
        hall.eventDispatcher.emit(hall.EventDefine.OTPGeted)
      } else {
        base.toast(serverErrorMsg(_msg.Ret))
        this.disconnectToLoginPanel()
      }
    }

    ;(hall.s2c as any)['onClient2ProxyAckMoblieLogin'] = (
      _msg: proto.Client2ProxyAckMoblieLogin,
    ) => {
      console.log('手机号登录 onClient2ProxyAckMoblieLogin')
      this.cleanBindInfo()
      if (_msg.Ret == 0) {
        this._preLoad = false
        this.setLastLoginType(LoginType.Mobile)

        base.app.token = _msg.Token
        this.loginByToken(base.app.token, _msg.FirstTime)
        if (_msg.FirstTime) {
          //base.sdkWrapper.traceAppEvent(AppEvents.CompleteRegistration)
        }
        hall.eventDispatcher.emit(hall.EventDefine.LoginAgain)
        this.loginType = LoginType.Mobile
        this.isFirstLogin = false
        this.loadingLogin()
      } else {
        base.toast(serverErrorMsg(_msg.Ret))
        this.loginFail()
      }
    }

    ;(hall.s2c as any)['onClient2ProxyAckTokenLogin'] = (_msg: proto.Client2ProxyAckTokenLogin) => {
      console.log('token 登录onClient2ProxyAckTokenLogin')
      if (_msg.Ret == 0) {
        this._preLoad = false

        hall.userModule.regaccount = (_msg as any).RegAccount || ''
        hall.userModule.userphone = (_msg as any).modileNum || ''
        hall.userModule.setUserInfo((_msg as any).userInfo)
        //base.sdkWrapper.traceAppEvent(AppEvents.Login)
        this.setLastLoginType(LoginType.Token)

        hall.eventDispatcher.emit(hall.EventDefine.LoginAgain)
        this.loginType = LoginType.Token
        this.isFirstLogin = false
        this.loadingLogin()
      } else {
        base.toast(serverErrorMsg(_msg.Ret))
        this.loginFail()
      }
    }

    ;(hall.s2c as any)['onClient2ProxyAckLogin'] = (_msg: proto.Client2ProxyAckLogin) => {
      console.log('游客登录onClient2ProxyAckLogin')
      if (_msg.Ret == 0) {
        base.uiHudSystem.hide('SystemTips')
        //base.app.token = (_msg as any).Token
        this._preLoad = false

        const lastLoginType =
          this._pendingReqLoginType === LoginType.Google ? LoginType.Google : LoginType.Guest
        this.setLastLoginType(lastLoginType)
        hall.userModule.setUserInfo(_msg.userInfo)
        if (_msg.FirstTime) {
          //base.sdkWrapper.traceAppEvent(AppEvents.CompleteRegistration)
          //base.sdkWrapper.traceAppEvent(AppEvents.Login)
        } else {
          if ((globalThis as any).fbEvent) {
            ;(globalThis as any).fbEvent((AppEvents as any).Login)
          }
          //base.sdkWrapper.traceAppEvent(AppEvents.Login)
        }

        hall.eventDispatcher.emit(hall.EventDefine.LoginAgain)
        this.loginType = lastLoginType
        this._pendingReqLoginType = LoginType.None
        this.isFirstLogin = false
        this.loadingLogin()
      } else {
        base.toast(serverErrorMsg((_msg as any).Ret))
        this.loginFail()
      }
    }

    ;(hall.s2c as any)['onClient2ProxyPushInGame'] = (_msg: proto.Client2ProxyPushInGame) => {}

    ;(hall.s2c as any)['onClient2ProxyAckLogout'] = (_msg: proto.Client2ProxyAckLogout) => {
      if (this.timePanel) {
        base.uiHudSystem.hide('SystemWaitingCopy')
        if (this.timePanel) {
          ;(Utility as any).cancelTimer(this.timePanel)
        }
        this.timePanel = null
      }

      this.setLastLoginType(LoginType.None)
      this.disconnectToLoginPanel()
      this.loginType = LoginType.None
      this.isFirstLogin = false
      base.app.token = ''
      // base.sdkWrapper.clearAccountId()
      ;(hall.moduleManager as any).isLoadingNow = false
    }

    ;(hall.s2c as any)['onClient2ProxyKickOutUser'] = (_msg: proto.Client2ProxyKickOutUser) => {
      const params = {
        callback: (tag: any) => {
          log('SystemTips callback tag =', tag)
          this.disconnectToLoginPanel()
          // base.sdkWrapper.clearAccountId()
        },
      }

      if ((hall.hallModule as any).merchant == 'self') {
        ;(hall.hallModule as any).merchant = null
      } else {
        base.uiHudSystem.show('SystemTips', hall.Language.user_kicked_out, params)
      }
    }

    ;(hall.s2c as any)['onClient2ProxyPushSysMain'] = (msg: proto.Client2ProxyPushSysMain) => {
      let content = bytesToString(msg.SysMainMsg)
      content = content.replace(/\\n/g, '\n')

      const mainBeginTime = msg.MainBeginTime
      const mainEndTime = msg.MainEndTime
      const strContent = `Service maintenance time: \n${mainBeginTime} -- ${mainEndTime}\n\n${content}`

      base.uiHudSystem.show('NoticePanel', strContent)
    }
  }

  reLogin() {
    this.deleView()
    hall.turnTableModule.onceShow = false
    wsClient.destroy()
    ;(hall.moduleManager as any).clearModules()

    const token = base.app.token
    if (token != null && token !== '') {
      this.loginByToken(token)
    } else {
      this.loginByGuest()
    }
  }
}
